const SERVER = process.env.REACT_APP_SERVER_DEFAULT;

const API_AUTHS = SERVER + "/ticket/login";
const USERS = SERVER + "/ticket/list_user";
const SERVICES = SERVER + "/ticket/list_layanan";
const DASHBOARD = SERVER + "/ticket/dashboard";
const ROLE = SERVER + "/ticket/list_role";
const GROUP = SERVER + "/ticket/list_group";
const ROLEUSERS = SERVER + "/ticket/list_role/user";
const CATEGORY = SERVER + "/ticket/list_kategori";
const LIST_ISSUE = SERVER + "/ticket/list_issue";
const LOG = SERVER + "/ticket/list_log";
const REPORT = SERVER + "/ticket/list_report";
const OPTION_MASTER = SERVER + "/ticket/list_master";
const LIST_NOTIF = SERVER + "/ticket/list_notif";
const LIST_EMAIL = SERVER + "/ticket/list_email";
const LIST_CONFIG = SERVER + "/ticket/list_config";
const LIST_PRIORITY = SERVER + "/ticket/list_priority";
const LIST_INCIDENT = SERVER + "/ticket/list_kecelakaan";

export const config = {
	server: SERVER,
	login: API_AUTHS,
	users: USERS,
	services: SERVICES,
	roleLayanan: ROLE,
	roleUsers: ROLEUSERS,
	category: CATEGORY,
	group: GROUP,
	list_issue: LIST_ISSUE,
	optionMaster: OPTION_MASTER,
	dashboard: DASHBOARD,
	log: LOG,
	report: REPORT,
	notification: LIST_NOTIF,
	list_email: LIST_EMAIL,
	list_config: LIST_CONFIG,
	list_priority: LIST_PRIORITY,
	list_incident: LIST_INCIDENT,
};
